export default __webpack_public_path__ + "static/media/elearning.7b54ef10.webp";